import React from 'react';

import i18n from 'i18next';

import { Button, ButtonGroup } from 'uikit/buttons';

const InitiativeFormActions = ({
  isSubmitDisabled,
  onSubmit,
  onCancel,
  submitText = i18n.t('save'),
}) => (
  <ButtonGroup>
    <Button
      color="brand"
      isDisabled={isSubmitDisabled}
      onClick={onSubmit}
      text={submitText}
    />
    <Button onClick={onCancel} text={i18n.t('cancel')} variant="ghost" />
  </ButtonGroup>
);

export default React.memo(InitiativeFormActions);
